var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRedeemCode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 140 141"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#redeem-code_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "redeem-code_svg__b",
  width: 140,
  height: 141,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M140 .5H0v140h140z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#redeem-code_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#47CFCB",
  fillRule: "evenodd",
  d: "M78.59 121.392H1.608c-.677 0-1.226-.484-1.226-1.081v-11.515c0-.597.549-1.082 1.226-1.082h6.573v-9.886c0-.597.549-1.08 1.226-1.08h6.704V47.093h-8.44c-.677 0-1.225-.483-1.225-1.08v-9.888H2.513c-1.11 0-2.081-.655-2.373-1.6-.291-.944.17-1.945 1.126-2.44L61.515.8c.77-.4 1.725-.4 2.494 0l60.25 31.285c.956.496 1.417 1.497 1.126 2.442-.292.944-1.264 1.6-2.374 1.6h-3.933v9.887c0 .597-.549 1.08-1.226 1.08h-8.44v30.292a34 34 0 0 0-3.07.222V47.094h-9.355v33.042a33 33 0 0 0-3.07 1.528v-34.57H70.509v49.653h9.458a33 33 0 0 0-1.116 2.71H11.253v8.257h65.762q-.125 1.341-.14 2.711H3.454v8.258h74.356q.334 1.378.78 2.709M9.516 36.126v8.26h106.491v-8.26zm22.09 10.968v49.653h23.407V47.094zm26.477 0v49.653h9.356V47.094zm-38.903 0v49.653h9.356V47.094zM4.755 33.417H120.77L62.762 3.296zm58.007-21.583c5.257 0 9.525 4.268 9.525 9.525s-4.268 9.526-9.525 9.526-9.525-4.269-9.525-9.526 4.268-9.526 9.525-9.526m0 2.71a6.82 6.82 0 0 0-6.815 6.815 6.82 6.82 0 0 0 6.815 6.816 6.82 6.82 0 0 0 6.816-6.816 6.82 6.82 0 0 0-6.816-6.815",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#47CFCB",
  fillRule: "evenodd",
  d: "M110.302 81.104c16.39 0 29.698 13.307 29.698 29.698S126.692 140.5 110.302 140.5c-16.392 0-29.7-13.308-29.7-29.698s13.308-29.698 29.7-29.698m8.725 25.223v-4.342a8.726 8.726 0 0 0-17.452 0v4.342h-1.036a3.41 3.41 0 0 0-3.413 3.413v15.192c0 .905.36 1.773 1 2.414.64.639 1.507.999 2.413.999h19.524a3.414 3.414 0 0 0 3.413-3.413V109.74a3.4 3.4 0 0 0-1-2.412 3.4 3.4 0 0 0-2.413-1.001zm1.036 2.715c.186 0 .363.074.494.204.13.132.204.31.204.494v15.192a.7.7 0 0 1-.204.494.7.7 0 0 1-.494.204h-19.524a.7.7 0 0 1-.494-.204.7.7 0 0 1-.204-.494V109.74c0-.184.074-.362.204-.494a.7.7 0 0 1 .494-.204zm-11.12 8.646v3.698a1.358 1.358 0 0 0 2.715 0v-3.698a2.97 2.97 0 0 0-1.357-5.608 2.97 2.97 0 0 0-1.358 5.608m1.358-1.808a.833.833 0 1 1 .001-1.665.833.833 0 0 1-.001 1.665m6.012-9.553h-12.024v-4.342c0-3.32 2.692-6.01 6.012-6.01s6.012 2.69 6.012 6.01z",
  clipRule: "evenodd"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "redeem-code_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h140v140H0z"
})))));
export default SvgRedeemCode;